/* eslint-disable jsx-a11y/media-has-caption */
import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import RecordButton from "./RecordButton.js";
import RecordingLength from "./RecordingLength.js";
import AudioSourceSelect from "./AudioSourceSelect.js";
import AudioOscilloscope from "./audio-oscilloscope/index.js";
import SubmitButton from "./SubmitButton.js";
import DiscardButton from "./DiscardButton.js";
export default function RecordingScreen(props) {
  var stream = props.stream,
    recordedAudio = props.recordedAudio,
    onStop = props.onStop,
    recording = props.recording,
    supportsRecording = props.supportsRecording,
    audioSources = props.audioSources,
    showAudioSourceDropdown = props.showAudioSourceDropdown,
    onSubmit = props.onSubmit,
    i18n = props.i18n,
    onStartRecording = props.onStartRecording,
    onStopRecording = props.onStopRecording,
    onDiscardRecordedAudio = props.onDiscardRecordedAudio,
    recordingLengthSeconds = props.recordingLengthSeconds;
  var canvasEl = useRef(null);
  var oscilloscope = useRef();

  // componentDidMount / componentDidUnmount
  useEffect(function () {
    return function () {
      oscilloscope.current = null;
      onStop();
    };
  }, [onStop]);

  // componentDidUpdate
  useEffect(function () {
    if (!recordedAudio) {
      oscilloscope.current = new AudioOscilloscope(canvasEl.current, {
        canvas: {
          width: 600,
          height: 600
        },
        canvasContext: {
          lineWidth: 2,
          fillStyle: 'rgb(0,0,0)',
          strokeStyle: 'green'
        }
      });
      oscilloscope.current.draw();
      if (stream) {
        var audioContext = new AudioContext();
        var source = audioContext.createMediaStreamSource(stream);
        oscilloscope.current.addSource(source);
      }
    }
  }, [recordedAudio, stream]);
  var hasRecordedAudio = recordedAudio != null;
  var shouldShowRecordButton = !hasRecordedAudio && supportsRecording;
  var shouldShowAudioSourceDropdown = showAudioSourceDropdown && !hasRecordedAudio && audioSources && audioSources.length > 1;
  return h("div", {
    className: "uppy-Audio-container"
  }, h("div", {
    className: "uppy-Audio-audioContainer"
  }, hasRecordedAudio ? h("audio", {
    className: "uppy-Audio-player",
    controls: true,
    src: recordedAudio
  }) : h("canvas", {
    ref: canvasEl,
    className: "uppy-Audio-canvas"
  })), h("div", {
    className: "uppy-Audio-footer"
  }, h("div", {
    className: "uppy-Audio-audioSourceContainer"
  }, shouldShowAudioSourceDropdown ? AudioSourceSelect(props) : null), h("div", {
    className: "uppy-Audio-buttonContainer"
  }, shouldShowRecordButton && h(RecordButton, {
    recording: recording,
    onStartRecording: onStartRecording,
    onStopRecording: onStopRecording,
    i18n: i18n
  }), hasRecordedAudio && h(SubmitButton, {
    onSubmit: onSubmit,
    i18n: i18n
  }), hasRecordedAudio && h(DiscardButton, {
    onDiscard: onDiscardRecordedAudio,
    i18n: i18n
  })), h("div", {
    className: "uppy-Audio-recordingLength"
  }, !hasRecordedAudio && h(RecordingLength, {
    recordingLengthSeconds: recordingLengthSeconds,
    i18n: i18n
  }))));
}